// Test IDs for search components

export const SEARCH_FLOW_TEST_IDS = {
  CONTAINER: 'search-flow-container',
  INPUT: 'search-flow-input',
  SEARCH_BTN: 'search-flow-search-btn',
} as const;

export const SEARCH_LIST_TEST_IDS = {
  CLOSE_BTN: 'search-list-close-btn',
  LIST: 'search-list',
  EMPTY_BTN: 'empty-search-list-btn',
  SELECT_LOW_STOCK_BTN: 'select-lowStock-btn',
  RESTOCK_DATE_BTN: 'search-restockDate-btn',
} as const;

